import styled from "styled-components";
import theme from "../../theme";

const selectType = ["돌봄 유형", "돌봄 일정", "돌봄 주소"];
const txtColor = theme.colors.black;

const PhoneNumberuserInfo = (props) => {
  const startYear = props.schedule.startDate.slice(0, 4);
  const startMonth = props.schedule.startDate.slice(5, 7);
  const startDay = props.schedule.startDate.slice(8, 13);

  const endYear = props.schedule.endDate.slice(0, 4);
  const endMonth = props.schedule.endDate.slice(5, 7);
  const endDay = props.schedule.endDate.slice(8, 13);
  let visitTime = parseInt(props.schedule.visitTime.slice(0, 2));

  return (
    <Container>
      <Title>신청내역</Title>
      <li className="first-list">
        <p className="sub-tit">{selectType[0]}</p>
        <span>
          {props.workType === "DAY" ? "🌞 24시간 상주" : "⏰ 시간제 돌봄"}
        </span>
      </li>
      <li className="second-list">
        <p className="sub-tit">{selectType[1]}</p>
        <span>
          {`${startYear}년 ${startMonth}월 ${startDay}일`} ~
          {`${endYear}년 ${endMonth}월 ${endDay}일`}
        </span>
        <br />
        <span className="se-txt">
          {!visitTime ? "0" : visitTime}
          시부터
        </span>
        <br />
        <span>{props.schedule.hour}시간</span>
      </li>
      <li className="three-list">
        <p className="sub-tit">{selectType[2]}</p>
        <span>{props.address.roadAddress}</span> <br />
        <span className="ad-txt">지번</span>
        <span className="se-txt">{props.address.jibunAddress}</span> <br />
        <span>
          {props.address.myundonName}
          {props.address.addressDetail}
        </span>
      </li>
    </Container>
  );
};

const Container = styled.div`
  width: 82.1vw;
  height: 452px;
  margin: 7.97vh 0 3.94vh;
  padding: 32px 16px 32px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.05), 0px 0px 5px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  box-sizing: border-box;
  overflow: auto;
  li {
    list-style: none;
    border-bottom: 1px solid #f6f6f6;
    padding: 0 0 18px;
    color: ${txtColor};
    &:last-child {
      padding: 0;
      border-bottom: none;
    }
    .sub-tit {
      margin: 0;
      padding: 1em 0 1em;
      font-weight: 700;
      font-size: 14px;
    }
    span {
      line-height: 26px;
    }
    .ad-txt {
      width: 35px;
      height: 20px;
      display: inline-block;
      font-size: 10px;
      color: #7d7878;
      background-color: white;
      background: rgba(125, 120, 120, 0.1);
      border-radius: 32px;
      text-align: center;
      line-height: 20px;
    }
  }
`;

const Title = styled.p`
  color: ${txtColor};
  font-weight: 700;
  font-size: 16px;
  margin: 0;
`;

export default PhoneNumberuserInfo;
